import { NavigationManager } from './navigation-manager';
import { Utils } from './util';
import { Resizer } from './resizer';

class Main {
    constructor() {
        Utils.changeFavicon('../assets/favicon-enable.ico');
        Utils.changePageTitle('DealTrack API');

        Utils.loadExternalJs(this.getEcsScriptUrl());

        document.getElementById('swagger-ui').classList.add('ecs_viewport');

        Resizer.observeHeight(this.targetElementFinder,
            () => document.getElementsByClassName('block-desktop')[0] as HTMLElement);

        const navHandler = new NavigationManager();

        const readyCheck = setInterval(() => {
            if (!navHandler.apiSectionsLoaded()) {
                return;
            }

            navHandler.enableScrolling();
            clearInterval(readyCheck);
        }, 50);
    }

    private targetElementFinder(): HTMLElement {
        const openSection = document.getElementsByClassName('opblock-tag-section is-open')[0];

        if (openSection) {
            return openSection.getElementsByTagName('h4')[0].nextSibling as HTMLElement;
        }

        return null;
    }

    private getCacheBusterDate(currentDate: Date): string {
        const formatWithLeadingZerosIfRequired = (monthOrDayValue: number): string =>
            monthOrDayValue < 10 ? `0${monthOrDayValue}` : monthOrDayValue.toString();

        const yyyy = currentDate.getFullYear();
        const mm = formatWithLeadingZerosIfRequired(currentDate.getMonth() + 1);
        const dd = formatWithLeadingZerosIfRequired(currentDate.getDate());

        return `${yyyy}${mm}${dd}`;
    }

    private getEcsScriptUrl(): string {
        const cacheBusterValue = this.getCacheBusterDate(new Date());

        const url = Utils.isLiveEnvironment() || Utils.isUatEnvironment() ?
            `https://website-tools.enable.com/js/ecs.js?d=${cacheBusterValue}` :
            `https://staging-website.enable.com/js/ecs.js?d=${cacheBusterValue}`;

        return url;
    }
}

// tslint:disable-next-line: no-unused-expression
new Main();
